exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* We have added this to fix the bug with DS web Switch component */\n/* This is a TEMPORARY fix */\n.settings-switches input {\n\tdisplay: none;\n\tmargin: 0;\n}\n", ""]);

